import apiClient from './apiClient';

export async function getOverviewTrend(weeks = 12) {
  const res = await apiClient.get('/analytics/overview-trend', { params: { weeks } });
  return res.data.data.items;
}
export async function getMisSummary() {
  const res = await apiClient.get('/analytics/mis-summary');
  return res.data.data.items;
}
export async function getPeriodComparison() {
  const res = await apiClient.get('/analytics/period-comparison');
  return res.data.data;
}
